/**
 * API методы для работы с пользователями: CRUD операции, активация/деактивация, сброс пароля
 * Дата: 28.12.2025 - Создан для TODO-013 (Frontend страницы + WhatsApp интеграция)
 * Дата: 05.02.2026 - TODO-054: Добавлены поля phone и allow_otp_login
 * Связан с: internal/handler/user.go, frontend/src/hooks/useUsers.ts, frontend/src/pages/Users.tsx
 */
import { apiClient } from './client';

export interface User {
  id: string;
  tenant_id?: string;
  role_id: string;
  role_name: string;
  username: string;
  email: string;
  full_name: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  // TODO-054: OTP Login (05.02.2026)
  phone?: string;
  allow_otp_login?: boolean;
}

export interface CreateUserRequest {
  username: string;
  email: string;
  full_name: string;
  password: string;
  role_id: string;
  // TODO-054: OTP Login (05.02.2026)
  phone?: string;
  allow_otp_login?: boolean;
}

export interface UpdateUserRequest {
  email?: string;
  full_name?: string;
  role_id?: string;
  // TODO-054: OTP Login (05.02.2026)
  phone?: string;
  allow_otp_login?: boolean;
}

export const usersApi = {
  // Дата: 29.12.2025 - Добавлена поддержка tenantId для SuperAdmin
  list: async (tenantId?: string): Promise<{ users: User[]; total: number }> => {
    const params: Record<string, string> = {};
    if (tenantId) params.tenant_id = tenantId;
    const response = await apiClient.get('/users', { params });
    return response.data;
  },

  get: async (id: string): Promise<User> => {
    const response = await apiClient.get(`/users/${id}`);
    return response.data;
  },

  create: async (data: CreateUserRequest): Promise<User> => {
    const response = await apiClient.post('/users', data);
    return response.data;
  },

  update: async (id: string, data: UpdateUserRequest): Promise<User> => {
    const response = await apiClient.put(`/users/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/users/${id}`);
  },

  resetPassword: async (id: string, password: string): Promise<{ password: string }> => {
    const response = await apiClient.post(`/users/${id}/reset-password`, { password });
    return response.data;
  },

  activate: async (id: string): Promise<void> => {
    await apiClient.post(`/users/${id}/activate`);
  },

  deactivate: async (id: string): Promise<void> => {
    await apiClient.post(`/users/${id}/deactivate`);
  },
};

